import { compose } from 'redux';
import {
    WithSessionStorage,
    WithNotifyRessourceLoaded,
    WithNotifyRessourceLoadedInputProps,
} from 'modules/shared/hocs';
import { readPageTitle } from 'modules/shared-cms/utils';
import { WithCMSSEO } from 'modules/shared-cms/hocs';
import {
    WithFetchDatasByParamsFromCMS,
    WithFetchDatasByParamsFromCMSInputProps,
} from 'modules/shared-cms-advanced/hocs';

import { Session, SessionName } from '../../models';

import { SignProps } from '.';
import { QUERY } from './sign-query';
import { SignLoader } from './sign-loader';

const enhancer = compose<
    React.ComponentType<WithFetchDatasByParamsFromCMSInputProps & WithNotifyRessourceLoadedInputProps>
>(
    WithFetchDatasByParamsFromCMS<SignProps>(SignLoader, QUERY, undefined, [{ filter: "data/signId/iv eq '$signId'" }]),
    WithNotifyRessourceLoaded((datas?: SignProps) =>
        readPageTitle(datas && datas.content && datas.content.length > 0 ? datas.content[0].data : undefined),
    ),
    WithCMSSEO(),
    WithSessionStorage<Session>(SessionName),
);
export default enhancer;
